import { LegalShell } from "./Privacy";

export default function Terms() {
  return (
    <LegalShell title="Terms of Service">
      <section>
        <h2>What The Pooh Sheet is</h2>
        <p>The Pooh Sheet is a sports research and information platform. We publish picks, statistics, analysis and tools for entertainment and informational purposes only. We are not a sportsbook, we do not accept or place wagers, and nothing on this site is financial or gambling advice.</p>
      </section>
      <section>
        <h2>No guarantees</h2>
        <p>Sports are unpredictable. Past performance of our picks does not guarantee future results. You are solely responsible for any wagers you choose to place with licensed operators. Never bet more than you can afford to lose.</p>
      </section>
      <section>
        <h2>Age and eligibility</h2>
        <p>You must be at least 21 years old (or the legal age in your jurisdiction) to use this site. It is your responsibility to comply with the laws where you live. If you or someone you know has a gambling problem, call 1-800-GAMBLER.</p>
      </section>
      <section>
        <h2>Accounts and subscriptions</h2>
        <p>Keep your login credentials private; you are responsible for activity on your account. Paid plans (Pro and VIP) are billed through Stripe. You can request cancellation at any time and you will keep access through the period you paid for. We reserve the right to suspend accounts that abuse the platform or the community.</p>
      </section>
      <section>
        <h2>Community rules</h2>
        <p>Keep it respectful. No harassment, hate speech, spam, scams or sharing of paid content outside the platform. We may remove content or accounts that break these rules.</p>
      </section>
      <section>
        <h2>Intellectual property</h2>
        <p>The picks, analysis, tools and branding on this site belong to The Pooh Sheet. Statistics are sourced from the official MLB Stats API. Sharing paid content publicly without permission is not allowed.</p>
      </section>
      <section>
        <h2>Limitation of liability</h2>
        <p>The site is provided as is. To the fullest extent allowed by law, The Pooh Sheet is not liable for any losses, including wagering losses, arising from use of the site or reliance on its content.</p>
      </section>
      <section>
        <h2>Changes</h2>
        <p>We may update these terms from time to time. Material changes will be reflected on this page. Continued use of the site means you accept the current terms.</p>
      </section>
    </LegalShell>
  );
}
